import React, { useEffect, useState } from "react"
import * as S from "./inisightsNavbarComponents/styles/InsightsNavbar.styles"
import Cell from "./inisightsNavbarComponents/Cell"
import Dropdown from "./inisightsNavbarComponents/Dropdown"
import FiltersContainer from "./inisightsNavbarComponents/FiltersContainer"
import { Search } from "../../assets/icons"
import CellWithChevron from "./inisightsNavbarComponents/CellWithChevron"
import { getInsightFilters } from "../../API/getFilters"
import { useDispatch } from "react-redux"
import { addFilter } from "../../store/actions/filters"
import Spinner from "../Spinner"

const InsightsNavbar = () => {
  const [showNavbar, setShowNavbar] = useState(false)
  const [filters, setFilters] = useState(null)
  const dispatch = useDispatch()

  const handleClick = () => {
    setShowNavbar(!showNavbar)
  }

  const handleSubmit = e => {
    e.preventDefault()

    dispatch(
      addFilter({
        name: e.target[0].value,
        category: "userInput",
      })
    )
    e.target[0].value = ""
  }

  useEffect(() => {
    const getData = async () => {
      const data = await getInsightFilters()
      setFilters(data)
    }
    getData()
  }, [])

  if (!filters) {
    return <Spinner />
  }

  // Those are the color scheme for the navbar
  const colors = {
    textColor: "var(--filtersBlue)",
    chevronColor: "var(--filtersBlue)",
    highlightColor: "var(--yellowCategory)",
  }

  return (
    <S.Container>
      <S.TitleSection>
        <h1>{"Healthcare & life Sciences Insights"}</h1>
        <S.InputContainer>
          <form onSubmit={e => handleSubmit(e)}>
            <S.Input placeholder="SEARCH"></S.Input>
            <Search />
          </form>
        </S.InputContainer>
      </S.TitleSection>
      <S.Navbar showNavbar={true}>
        {filters.categories.map((insightType, index) => (
          <Cell {...insightType} key={index} colors={colors} />
        ))}
      </S.Navbar>
      <CellWithChevron
        text={"Filter by"}
        handleClick={handleClick}
        onlyMobile
        colors={colors}
      />
      <S.Navbar showNavbar={showNavbar}>
        {/* <Dropdown
          text={"expertise"}
          category={"expertise"}
          filters={filters.expertise}
          colors={colors}
        /> */}
        {/* <Dropdown
          text={"industry"}
          category={"industries"}
          filters={filters.industries}
          colors={colors}
        /> */}
        <Dropdown
          text={"country"}
          category={"region"}
          filters={filters.region}
          colors={colors}
        />
        <Dropdown
          text={"media type"}
          category={"media"}
          filters={filters.content_type}
          colors={colors}
        />
        <Dropdown
          text={"published date"}
          filters={filters.date}
          category={"date"}
          colors={colors}
        />
      </S.Navbar>
      <FiltersContainer colors={colors} />
    </S.Container>
  )
}

export default InsightsNavbar
